var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileMinutes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.628 6.965v26.067c0 2-1.77 3.633-3.96 3.633h-9.69c-2.208 0-3.978-1.633-3.978-3.633V6.965c0-2 1.77-3.633 3.978-3.633h9.69c2.19 0 3.96 1.633 3.96 3.633z",
    fill: "url(#pvfdnu5k6a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M10 6.965v26.067c0 2 1.77 3.633 3.978 3.633h2.372c-2.19 0-3.978-1.633-3.978-3.633V6.965c0-2 1.77-3.633 3.96-3.633H13.96c-2.19 0-3.96 1.633-3.96 3.633z",
    fill: "url(#9e16dd9z1b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.532h20m-11.57-22.4h3.14m-7.592-3.8h12.044C28.219 3.332 30 4.959 30 6.965v26.067c0 2.007-1.781 3.633-3.978 3.633H13.978c-2.197 0-3.978-1.626-3.978-3.633V6.965c0-2.006 1.781-3.633 3.978-3.633z",
    stroke: "url(#w75ikx3lhc)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.05c.695 0 1.259-.515 1.259-1.15 0-.635-.564-1.15-1.26-1.15-.695 0-1.259.515-1.259 1.15 0 .635.564 1.15 1.26 1.15z",
    fill: "url(#sr6e8c5dzd)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pvfdnu5k6a",
    x1: 10,
    y1: 22.716,
    x2: 28.796,
    y2: 19.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e16dd9z1b",
    x1: 10,
    y1: 22.716,
    x2: 16.946,
    y2: 22.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w75ikx3lhc",
    x1: 10,
    y1: 22.716,
    x2: 31.149,
    y2: 18.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sr6e8c5dzd",
    x1: 18.74,
    y1: 33.087,
    x2: 21.192,
    y2: 32.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMinutes);
export default __webpack_public_path__ + "static/media/mobileMinutes.b15851c88d0d1332f478d45f0f9f8952.svg";
export { ForwardRef as ReactComponent };